import { ConfigProvider } from "antd"
import { useTranslation } from "react-i18next"
import frFR from "antd/locale/fr_FR"
import enUS from "antd/locale/en_US"
import viVN from "antd/locale/vi_VN"
import Pages from "./components/pages/Pages"

const antdLocales: Record<string, typeof frFR> = {
  fr: frFR,
  en: enUS,
  vn: viVN,
}

function App() {
  const { i18n } = useTranslation()

  return (
    <ConfigProvider locale={antdLocales[i18n.language] || enUS}>
      <Pages />
    </ConfigProvider>
  )
}

export default App
